export const statusList = [
	{ id: '', name: 'Todos' },
	{ id: 'true', name: 'Ativos' },
	{ id: 'false', name: 'Desativados' },
];

export const typeCompany = [
	{ id: 'JN', name: 'Jurídica' },
	{ id: 'FS', name: 'Física' },
];

export const salesFlowSteps = [
	{ id: 1, name: 'Solicitações' },
	{ id: 2, name: 'Proposta Comercial' },
	{ id: 3, name: 'Análise Comercial' },
	{ id: 4, name: 'Análise de Crédito' },
	{ id: 5, name: 'Pedido de Venda' },
];

export const statusMonitoramento = [
	{ id: 1, name: 'Concluído' },
	{ id: 2, name: 'Em andamento' },
	{ id: 3, name: 'Equipamento em casa' },
	{ id: 4, name: 'Equipamento instalado' },
	{ id: 5, name: 'Esperando equipamento' },
	{ id: 6, name: 'não iniciado' },
];

export const subMercado = [
	{ id: 1, name: 'Nordeste' },
	{ id: 2, name: 'Norte' },
	{ id: 3, name: 'Sul' },
	{ id: 4, name: 'Suldeste' },
];

export const categoriaClient = [
	{ id: 1, name: 'Especial' },
	{ id: 2, name: 'Livre' },
	{ id: 3, name: 'Auto Produtor' },,
];

export const assemblyOptions = [
	{ id: '1', name: 'TKA - Montagem Fábrica' },
	{ id: '2', name: 'Implementadora' },
	{ id: '3', name: 'Cliente' },
];

export const proposalType = [
	{ id: '1', name: 'Normal' },
	{ id: '2', name: 'Especial' },
];

export const subgroups = [
	{ id: 1, name: 'A2' },
	{ id: 2, name: 'A3' },
	{ id: 3, name: 'A3A' },
	{ id: 4, name: 'A4' },
	{ id: 5, name: 'AS' },
]

export const meses = [
	{ id: 1, name: 'Janeiro' },
	{ id: 2, name: 'Fevereiro' },
	{ id: 3, name: 'Março' },
	{ id: 4, name: 'Abril' },
	{ id: 5, name: 'Maio' },
	{ id: 6, name: 'Junho' },
	{ id: 7, name: 'Julho' },
	{ id: 8, name: 'Agosto' },
	{ id: 9, name: 'Setembro' },
	{ id: 10, name: 'Outubro' },
	{ id: 11, name: 'Novembro' },
	{ id: 12, name: 'Dezembro' },
]